import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "#e8eaed"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M356-228h164q21.25 0 35.63-14.38Q570-256.75 570-278v-30l84 44v-192l-84 44v-30q0-21.25-14.37-35.63Q541.25-492 520-492H356q-21.25 0-35.62 14.37Q306-463.25 306-442v164q0 21.25 14.38 35.62Q334.75-228 356-228ZM236-48q-43.73 0-74.86-31.14Q130-110.28 130-154v-652q0-43.72 31.14-74.86Q192.27-912 236-912h314l280 282v476q0 43.72-31.14 74.86T724-48H236Zm260-530v-228H236v652h488v-424H496ZM236-806v228-228 652-652Z" }, null, -1)
  ]))]))
}
export default { render: render }